import { goSolidApi } from "@/composables/useGoSolidApi";

export interface IssuanceCapabilities {
  can_import: boolean;
  export_countries: string[];
}

export interface ProductionImportResponse {
  imported_count: number;
  rejected_count: number;
  rejections: {
    record_index: number;
    registry_device_id: number;
    external_id: string | null;
    period_start_at: string;
    period_end_at: string;
    error_code: "duplicate_record" | "invalid_record";
    message: string;
  }[];
}

export const issuanceReportingApi = {
  /** Read the current account's import permission and supported file exports. */
  capabilities: (companyId: number) =>
    goSolidApi.get<IssuanceCapabilities>(
      `/issuance-reporting/companies/${companyId}/capabilities`
    ),
  /** Import production readings and report both saved and rejected records. */
  importFile: (companyId: number, data: FormData) =>
    goSolidApi.post<ProductionImportResponse>(
      `/issuance-reporting/companies/${companyId}/issuance-production-data/import`,
      data
    ),
};
